import React from 'react'
import PropTypes from 'prop-types'
import Text from '../Text/Text'
import Image from '../Image/Image'
import styles from './notificationCard.scss'
import NotificationCardFeedbackHeader from './NotificationCardFeedbackHeader'
import colors from '../../styles/theme/colors.scss'
import defaultProductIcon from './defaultProductIcon.svg'

const NotificationCardHeader = (props) => {
  const {
    createdAtDate,
    productId,
    productIcon,
    isRead,
    isInterected,
    showRemoveConfirm
  } = props

  // Render feedback either if the notification is not read, or not interected
  const renderFeedback = !isRead || !isInterected

  return (
    <div className={styles.header}>
      <Image
        className={styles.icon}
        id={productId}
        alt="product icon"
        src={productIcon}
        fallback={defaultProductIcon}
      />

      <div className={styles.date}>
        <Text
          label={createdAtDate}
          labelFontSize="12px"
          color={colors.secondaryTextColor}
        />
        {renderFeedback && (
          <NotificationCardFeedbackHeader
            isRead={isRead}
            isInterected={isInterected}
          />
        )}

        <div
          role="button"
          tabIndex={0}
          className={styles.remove}
          onClick={showRemoveConfirm}
          onKeyDown={showRemoveConfirm}
        >
          <Image src={'/assets/img/icons/cdn/trash.svg'} alt="status" />
        </div>
      </div>
    </div>
  )
}

NotificationCardHeader.defaultProps = {
  createdAtDate: null,
  productId: null,
  productIcon: null,
  isRead: null,
  isInterected: null,
  showRemoveConfirm: null
}

NotificationCardHeader.propTypes = {
  createdAtDate: PropTypes.string,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  productIcon: PropTypes.string,
  isRead: PropTypes.bool,
  isInterected: PropTypes.bool,
  showRemoveConfirm: PropTypes.func
}

export default NotificationCardHeader
